export default function setStyle(variant) {
    if (!variant) {
        return 'normal';
    }

    const italic = variant.includes('italic');

    if (!italic) {
        return 'normal';
    }

    return 'italic';
}
